import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { defineMultiStyleConfig, definePartsStyle } =
  createMultiStyleConfigHelpers([
    "rowContainer",
    "rowWrapContainer",
    "statsAndActions",
    "colContainer",
    "backButton",
    "titleAndActions",
    "title",
    "titleBadge",
    "actions",
  ]);

const PageHeaderTheme = defineMultiStyleConfig({
  baseStyle: {
    rowContainer: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      alignItems: "flex-start",
      gap: "8px",
    },
    colContainer: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      alignItems: "stretch",
      gap: "4px",
    },
    statsAndActions: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: "8px",
    },
    backButton: {
      alignSelf: "flex-start",
      alignItems: "center",
      gap: "4px",
      lineHeight: "20px",
      color: "gray.600",
      _hover: {
        color: "gray.900",
      },
      _active: {
        color: "primary.600",
      },
    },
    titleContainer: {
      alignItems: "flex-start",
      spacing: 0,
      gap: "8px",
    },
    titleAndActions: {
      justifyContent: "space-between",
      minHeight: "36px",
    },
    title: {
      display: "inline-flex",
      alignItems: "center",
      whiteSpace: "nowrap",
    },
    titleBadge: {
      ml: "8px",
    },
    workflowName: {
      textStyle: "overline",
    },
    actions: {
      display: "flex",
      gap: "8px",
      alignItems: "center",
      color: "gray.400",
    },
  },
  sizes: {
    lg: definePartsStyle({
      rowContainer: {
        py: "24px",
      },
      colContainer: {
        gap: "8px",
      },
      title: {
        textStyle: "h2",
      },
    }),
    sm: definePartsStyle({
      rowContainer: {
        py: "16px",
      },
      colContainer: {
        gap: "4px",
      },
      title: {
        textStyle: "h3",
      },
    }),
  },
  defaultProps: {
    size: "sm",
  },
});

export default PageHeaderTheme;
